import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { mapActions } from "vuex";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "house-audit",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 10,
        new: "",
        phone: this.$route.query.phone
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      adminList: [],
      tableLoading: true,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      tableColumn: {
        houseCode: {
          key: "houseCode",
          name: "房源编号",
          width: 120,
          visible: true
        },
        userName: {
          key: "userName",
          name: "姓名",
          width: 140,
          visible: true
        },
        remark: {
          key: "remark",
          name: "备注",
          width: 120,
          visible: true
        },
        imCount: {
          key: "imCount",
          name: "消息数",
          width: 80,
          visible: true
        },
        realName: {
          key: "realName",
          name: "实名信息",
          width: 80,
          visible: true
        },
        userPhone: {
          key: "userPhone",
          name: "手机号",
          width: 120,
          visible: true
        },
        userTag: {
          key: "userTag",
          name: "用户标签",
          width: 200,
          visible: true
        },
        address: {
          key: "address",
          name: "详细地址",
          width: 200,
          visible: true
        },
        authInfo: {
          key: "authInfo",
          name: "认证信息",
          width: 100,
          visible: true
        },
        houseTag: {
          key: "houseTag",
          name: "房源标签",
          width: 100,
          visible: true
        },
        rent: {
          key: "rent",
          name: "租金",
          width: 100,
          visible: true
        },
        deposit: {
          key: "deposit",
          name: "押金",
          width: 100,
          visible: true
        },
        rentType: {
          key: "rentType",
          name: "租房类型",
          width: 100,
          visible: true
        },
        district: {
          key: "district",
          name: "地区",
          width: 100,
          visible: true
        },
        status: {
          key: "status",
          name: "状态",
          width: 100,
          visible: true
        },
        create: {
          key: "create",
          name: "发布时间",
          width: 100,
          visible: true
        },
        update: {
          key: "update",
          name: "编辑时间",
          width: 100,
          visible: true
        },
        loginTime: {
          key: "loginTime",
          name: "登录时间",
          width: 100,
          visible: true
        },
        adminUser: {
          key: "adminUser",
          name: "审核人员",
          width: 100,
          visible: true
        }
      },
      tableColumnFilterVisible: false,
      pageDB: null,
      remarkDialogVisible: false,
      currentRemarkObj: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            // 新增列
            if (data.tableColumn && data.tableColumn.userTag && data.tableColumn.update) {
              data.tableColumn && (_this.tableColumn = data.tableColumn);
            }
            if (data.searchForm) {
              _this.searchForm.new = data.searchForm.new;
              _this.searchForm.pn = data.searchForm.pn;
              _this.searchForm.cityId = data.searchForm.cityId;
              _this.searchForm.districtId = data.searchForm.districtId;
            }
            _this.getData();
            _this.getHouseFilterType();
            _this.getAdminList();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    searchForm: {
      handler: function handler() {
        var _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (_this2.pageDB) {
                  _this2.pageDB.set("searchForm", _this2.searchForm).write();
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }))();
      },
      deep: true
    },
    tableColumn: {
      handler: function handler() {
        var _this3 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this3.$nextTick(function () {
                  _this3.$refs.filterTable.doLayout();
                  console.log("doLayout");
                  _this3.pageDB.set("tableColumn", _this3.tableColumn).write();
                });
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }))();
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("d2admin/db", ["database", "get"])), mapActions("d2admin/db", ["databasePage", "databasePageClear"])), {}, {
    tableHeaderDragend: function tableHeaderDragend(newWidth, oldWidth, column, event) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.tableColumn[column.columnKey].width = newWidth;
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    goChat: function goChat(row) {
      window.open("#/im/chat?otherId=".concat(row.userInfo.id));
    },
    goConversationList: function goConversationList(row) {
      window.open("#/im/conversation?id=".concat(row.userInfo.id));
    },
    getAdminList: function getAdminList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context5.v;
              _this5.adminList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/house/update",
        query: {
          id: row.id,
          userId: row.userInfo.id,
          from: this.$operationLog.editFrom({
            user_type: row.userInfo.user_type,
            status: row.status
          })
        }
      });
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getUserDeviceRiskBatch: function getUserDeviceRiskBatch() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              userIds = [];
              _this6.tableData.forEach(function (item) {
                if (userIds.indexOf(item.userInfo.id) == -1) {
                  userIds.push(item.userInfo.id);
                }
              });
              _context7.n = 1;
              return _this6.$api.getUserDeviceRiskBatch({
                user_ids: userIds.join(",")
              });
            case 1:
              res = _context7.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _this6.tableData.forEach(function (item, index) {
                        if (item.userInfo.id == key) {
                          _this6.$set(item, "deviceRiskInfo", res.data[key]);
                        }
                      });
                    case 1:
                      return _context6.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context7.n = 4;
                break;
              }
              key = _t2.value;
              return _context7.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context7.n = 2;
              break;
            case 4:
              return _context7.a(2);
          }
        }, _callee6);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var userIds, res, _loop2, key, _t3, _t4;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              userIds = [];
              _this7.tableData.forEach(function (item) {
                if (userIds.indexOf(item.userInfo.id) == -1) {
                  userIds.push(item.userInfo.id);
                }
              });
              _context9.n = 1;
              return _this7.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context9.v;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(key) {
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      _this7.tableData.forEach(function (item, index) {
                        if (item.userInfo.id == key) {
                          _this7.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context8.a(2);
                  }
                }, _loop2);
              });
              _t3 = _regeneratorKeys(res.data);
            case 2:
              if ((_t4 = _t3()).done) {
                _context9.n = 4;
                break;
              }
              key = _t4.value;
              return _context9.d(_regeneratorValues(_loop2(key)), 3);
            case 3:
              _context9.n = 2;
              break;
            case 4:
              return _context9.a(2);
          }
        }, _callee7);
      }))();
    },
    getData: function getData(type) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var price, res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (type === "search") {
                _this8.searchForm.pn = 1;
              }
              if (_this8.searchForm.priceId && _this8.searchForm.priceId.length > 0) {
                price = _this8.searchForm.priceId.split(",");
                _this8.searchForm.minPrice = price[0];
                _this8.searchForm.maxPrice = price[1];
              }
              _this8.searchForm.type = 2; // 待审核
              _this8.tableLoading = true;
              _context0.n = 1;
              return _this8.$api.getHouseList(_this8.searchForm);
            case 1:
              res = _context0.v;
              res.data.list.forEach(function (item) {
                item.userTag = [];
              });
              // let tableData = await this.getUsersTagList(res.data.list);
              // this.tableData = tableData;
              _this8.tableData = res.data.list;
              _this8.total = res.data.count;
              _this8.tableLoading = false;
              _context0.n = 2;
              return _this8.getUsersTagList();
            case 2:
              _context0.n = 3;
              return _this8.getUserDeviceRiskBatch();
            case 3:
              _this8.getUserScoreList(_this8.tableData);
              _this8.tableData.forEach(function (item) {
                return item.userId = item.userInfo.id;
              });
              _this8.getUserListByIds(_this8.tableData, "userId", "", "newUser");
            case 4:
              return _context0.a(2);
          }
        }, _callee8);
      }))();
    },
    getUserScoreList: function getUserScoreList(data) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var userIds, res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              userIds = [];
              data.forEach(function (item) {
                var userType = item.userInfo.user_type;
                if (!userType) userIds.push(item.userInfo.id);
              });
              userIds = _toConsumableArray(new Set(userIds));
              _context1.n = 1;
              return _this9.$api.queryUserScoreById({
                userIds: userIds
              });
            case 1:
              res = _context1.v;
              if (res && res.data.length) {
                _this9.tableData.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.userInfo.id;
                  });
                  _this9.$set(item.userInfo, 'userScore', userScore || {});
                });
              }
            case 2:
              return _context1.a(2);
          }
        }, _callee9);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return _this0.$api.getHouseFilterType();
            case 1:
              res = _context10.v;
              _this0.filterList = res.data;
              _this0.getDistrictList();
            case 2:
              return _context10.a(2);
          }
        }, _callee0);
      }))();
    },
    getDistrictList: function getDistrictList() {
      var _this1 = this;
      this.districtList = [];
      if (this.searchForm.cityId && this.searchForm.cityId.length > 0) {
        this.filterList.cityList.forEach(function (item) {
          if (_this1.searchForm.cityId.indexOf(item.id) > -1) {
            _this1.districtList = _this1.districtList.concat(item.item);
          }
        });
      } else {
        this.districtList = [];
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      if (row.censor_status == "block") {
        return "warning-row";
      }
      return "";
    }
  })
};